/// <amd-module name="Wit/Common/AutomationRulesService/Contracts/Contracts" />
export interface IAutomationRulesSettings {
    workItemTypeName: string;
    teamId: string;
    rulesStates: { [key: string]: boolean };
}

export interface WorkItemAutomationRuleSettings {
    workItemAutomationRules: IAutomationRulesSettings[];
    workItemTypeMappedStates: WorkItemTypeStateInfoWithOrder[];
}

export interface WorkItemTypeStateInfoWithOrder {
    workItemTypeName: string;
    states: ShortStateInfo[];
}

export interface ShortStateInfo {
    state: string;
    category: WorkItemStateCategory;
}

export enum WorkItemStateCategory {
    Proposed = 1000,
    InProgress = 2000,
    Resolved = 3000,
    Completed = 4000,
    Removed = 5000
}

export namespace AutomationRuleNames {
    export const ActivateParentWhenAnyChildActivated = "ActivateParentWhenAnyChildActivated";
    export const CompleteParentWhenAllChildrenCompleted = "CompleteParentWhenAllChildrenCompleted";
    export const ResolveParentWhenAllChildrenResolved = "ResolveParentWhenAllChildrenResolved";
}
